export const BootstrapErrorContainerStyle = {
  height: '100%',
  width: '100%',
} as const;

export const BootstrapErrorButtonStyle = {
  mt: 3,
  color: 'white',
  borderColor: 'white',
} as const;
